var DB_VideoSlider = {
    init:function(){

        var _swiper_container = document.querySelector(".DB-video-slider .swiper-container");

        var swiper = new Swiper(_swiper_container, {
            slidesPerView: "auto",
            spaceBetween: 50,
            loop:true,
            freeMode:true,
            speed:5000,
        });

        var _swiper_mobile_container = document.querySelector(".DB-video-slider .swiper-mobile-container");

        var swiper_mobile = new Swiper(_swiper_mobile_container, {
            slidesPerView: "auto",
            spaceBetween: 30,
            loop:false,
            centeredSlides:true, 
            speed:1000,
            navigation: {
                nextEl: _swiper_mobile_container.querySelector(".swiper-button-next"),
                prevEl: _swiper_mobile_container.querySelector(".swiper-button-prev"),
            },
            pagination: {
                el: _swiper_mobile_container.querySelector(".swiper-pagination"),
                clickable:true
            }
        });

        document.querySelectorAll(".DB-video-slider .video-container").forEach(function(video_player){
            video_player.addEventListener("click", function(){
                if(video_player.classList.contains("playing")){
                    DB_VideoSlider.pause_video(video_player);
                }else{
                    DB_VideoSlider.play_video(video_player);
                }
            });
        })

    },
    play_video:function(video_player){
        console.log("PLAY VIDEO");

        // STOP OTHER VIDEO  //
        /*
        
        document.querySelectorAll(".DB-video-slider .video-container").forEach(function(other_player){
            if(other_player.classList.contains("playing")){                
                DB_VideoSlider.pause_video(other_player);    
            }          
        });
*/
        setTimeout(function(){
            video_player.querySelector("video").play();
            video_player.classList.add("playing");
        }, 40);

    },
    pause_video:function(video_player){
        console.log("PAUSE VIDEO");
        video_player.querySelector("video").pause();
        video_player.querySelector("video").currentTime = 0;
        video_player.classList.remove("playing");
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-video-slider").length > 0){
        DB_VideoSlider.init();
    }
})